const doc = [({"da":({"js":({"components":({"contents":({"editor":({"add_absolute_container":"Tilføj absolut container"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;